module.exports = __webpack_public_path__ + "img/side_menu_sub01.8e809752.png";